function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useRef, forwardRef } from "react";
import ReactDOM from "react-dom";
import { useTunnel, useTunnelView } from "./cache";
var Tunnel = /*#__PURE__*/ forwardRef(function Tunnel(props, ref) {
    var _props_mask = props.mask, mask = _props_mask === void 0 ? false : _props_mask;
    var name = props.name, children = props.children, target = props.target, _props_before = props.before, before = _props_before === void 0 ? false : _props_before;
    var beforeRef = useRef(null);
    var afterRef = useRef(null);
    useTunnel({
        name: name,
        beforeRef: beforeRef,
        afterRef: afterRef
    });
    var targetTunnel = useTunnelView({
        name: target
    });
    var render = [
        /*#__PURE__*/ _jsx("div", {
            ref: beforeRef,
            className: "lapel-pass-through lapel-pass-through__before"
        }, "before")
    ];
    if (targetTunnel) {
        // mask content when rendering to another location
        var targetRef = before ? targetTunnel.beforeRef : targetTunnel.afterRef;
        if (targetRef && targetRef.current) {
            mask = true;
            render.push(/*#__PURE__*/ ReactDOM.createPortal(children, targetRef.current));
        }
    }
    if (!mask) {
        var _children;
        if (((_children = children) == null ? void 0 : _children.length) === 1) {
            render.push(/*#__PURE__*/ React.cloneElement(children, _extends({}, children.props, {
                ref: ref
            })));
        } else {
            render.push(children);
        }
    }
    render.push(/*#__PURE__*/ _jsx("div", {
        ref: afterRef,
        className: "lapel-pass-through lapel-pass-through__after"
    }, "after"));
    return render;
});
export { Tunnel };

//# sourceMappingURL=Tunnel.js.map